/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { theme } from "styles/theme";

const HeaderContainer = styled.div`
    display: flex;
    padding: 14px 24px;
    gap: 10px;
    align-items: center;
    border-bottom: 1px solid ${theme.neutral100};
`;

const HeaderItem = styled.p<{ width: number }>`
    color: ${theme.neutral400};
    font-size: 14px;
    font-weight: 500;
    width: ${(props) => props.width + "px"};
`;
export const Header = () => {
    return (
        <HeaderContainer>
            <HeaderItem width={100}>방문자</HeaderItem>
            <HeaderItem width={158}>연락처</HeaderItem>
            <HeaderItem width={100}>개인정보 동의</HeaderItem>
            <HeaderItem width={140}>방문자 상태</HeaderItem>
            <HeaderItem width={82}>안내 채널</HeaderItem>
            <HeaderItem width={80}>전송 여부</HeaderItem>
        </HeaderContainer>
    );
};

export default Header;
